import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, GuardResult, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@services/auth.service';

@Injectable({ providedIn: 'root' })
export class OrgGuard implements CanActivate, CanActivateChild {
    auth = inject(AuthService);
    router = inject(Router);
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<GuardResult> {
        return await this.checkOrgAuth(route);
    }

    async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<GuardResult> {
        return await this.checkOrgAuth(childRoute);
    }

    async checkOrgAuth(route: ActivatedRouteSnapshot): Promise<GuardResult> {
        let user = await this.auth.get();
        // Child routes (funpay/:id, admin/users/:id) reuse the `id` param name, so read it from the org route itself.
        let orgId = this.findOrgId(route) ?? this.auth.organizationId();

        if (user && user.type == 'GLOBAL' && user.organizationData && user.organizationData[orgId]) {
            if (!Object.prototype.hasOwnProperty.call(user.organizationData, orgId)) {
                return this.router.parseUrl('/');
            }
            
            if (this.auth.organizationId() !== orgId || !this.auth.organization()) {
                await this.auth.setOrganization(orgId);
            }
            return true;
        }

        return this.router.parseUrl('/');
    }

    private findOrgId(route: ActivatedRouteSnapshot | null): string | null {
        for (let r = route; r; r = r.parent) {
            if (r.routeConfig?.path === 'organizations/:id') {
                return r.paramMap.get('id');
            }
        }
        return null;
    }
}
